import React from 'react';
import {P1, SectionTitle} from "../Kit/Kit";
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";

const Container = styled.div`
  display: grid;
  grid-row-gap: 16px;
  
  @media(min-width: 992px){
      //padding: 60px 0 80px;
      grid-row-gap: 24px;
  }
  @media(min-width: 1200px){
        //padding: 90px 0 0;
  }
`;

const Description = (props) => {
    const {header, paragraph} = props;
    return (
      <BodyContainer>
          <Container>
              <SectionTitle
                dangerouslySetInnerHTML={{__html: header}}
              />
              <P1
                dangerouslySetInnerHTML={{__html: paragraph}}
              />
          </Container>
      </BodyContainer>

    );
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/Affiliations/Description.js